import { render, staticRenderFns } from "./new_line_discussion_form.vue?vue&type=template&id=51451c65"
import script from "./new_line_discussion_form.vue?vue&type=script&lang=js"
export * from "./new_line_discussion_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports